import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/customer/customer.query.gql"
import type {
  CustomerQuery,
  CustomerQueryVariables,
} from "@/v2-backoffice-client/customer/__types__/customer.query"

type Options = QueryHookOptions<CustomerQuery, CustomerQueryVariables>

export function useCustomerQuery(options?: Options) {
  return useQuery<CustomerQuery, CustomerQueryVariables>(query, options)
}
